module.exports = __webpack_public_path__ + "img/m-keshihuashitu.3f419a86.svg";